export default __webpack_public_path__ + "static/media/germany.b3118925.svg";